var Triggers = new (class Triggers extends AbstractModule {

  constructor() {
    super("Triggers");
  }

  _initData(data) {
    this._autoInit({
      "_triggers"                 : [ data.guest.trigger, [] ],
      "_message_trigger"          : [ null, null ],
      "_greetings_replaced"       : [ null, false ],
      "_elements_moved_for_topbar": [ null, [] ],
      "_topbar_height"            : [ null, 0 ],
      "_scheduled_triggers"       : [ null, [] ]
    });
  }

  _initAfterGuest() {
    Promise.all([
      Conversations.when('ready'),
      Dom.when('ready')
    ]).then(() => {
      this._initTriggers();
    });
  }

  _initTriggers() {
    this.processTriggersList(this._triggers)

    if (!Views.widget_open) {
      let conversation = Conversations.get(null);

      if (conversation) {
        let next = async () => {
          if (conversation && conversation.greeting_message && !this._isWelcomeBubbleReplaced()) {
            if (this.app.isLive() && this.app._display_bubble && this.app._show_welcome_message && !this.app._hasCookieMessage()) {
              Utils.setCookie('slaask-message-' + this.app._api_key, Utils.generateRandomToken(), 1);
              await Utils.delay(this.app._time_before_message);
              Notifier.displayBubble(conversation.greeting_message, this.app._time_showing_message);
            }
          }
        };
        if (conversation.lifeSpanInitialized) next();
        else conversation.on('life-span-init', next);
      }
    }
  }

  processTriggersList (triggers) {
    const existingIds = this._triggers.map(trigger => trigger.id)
    triggers.forEach(trigger => {
      if (!~existingIds.indexOf(trigger.id)) {
        this._triggers.push(trigger)
      }
    })
    let hasLive = Conversations.hasLive();
    for (var i = triggers.length - 1; i >= 0; i--) {
      if ((this.app.isLive() || triggers[i].offline_activated) && (!hasLive || triggers[i].kind != 'message' || triggers[i].can_trigger_with_open_conversation)) {
        this.sendTrigger(triggers[i]);
        if (triggers[i].replace_greetings)
          this._greetings_replaced = true;
      }
    }
  }


  getTriggers() {
    return this._triggers;
  }

  get(triggerId) {
    triggerId = parseInt(triggerId);
    return this._triggers.filter(trigger => trigger.id == triggerId)[0];
  }

  clearScheduledTriggers() {
    this._scheduled_triggers.forEach(timeoutId => {
      this._clearTimeout(timeoutId);
    })
  }

  clearTriggers() {
    this.clearScheduledTriggers();
    Notifier.removeAllBubbles();
    this.removeTopbar();
  }

  /**
   * [sendTrigger description]
   * @param  {[type]} trigger [description]
   * @return {[type]}         [description]
   */
  sendTrigger(trigger) {
    if (!this.app._nativeSdk) {
      if (trigger.kind !== "chat_opening" && (trigger.message == null || trigger.message == '')) {
        return false;
      } else {
        if (trigger.time < 2000 && trigger.kind == 'topbar') {
          trigger.time = 2000
        }
        const timeoutId = this._setTimeout(() => {
          this._scheduled_triggers.splice(this._scheduled_triggers.indexOf(timeoutId), 1);
          if (trigger.kind == 'alert' || trigger.kind == 'alert_email') {
            this.sendTriggerAlert(trigger, false);
          }
          else if (trigger.kind == 'tooltip') {
            this.sendTriggerTooltip(trigger);
          }
          else if (trigger.kind == 'topbar') {
            this.sendTriggerTopbar(trigger);
          }
          else if (trigger.kind == 'chat_opening') {
            this.app._triggerInternalEvent('trigger_' + trigger.kind, {
              'time': trigger.time
            });
            Dom.showWidget({ by: 'trigger' })
          }
          else {
            let tabTriggers = [];
            try {
              tabTriggers = JSON.parse(trigger.message)
            } catch(e) {
              tabTriggers = [{message: trigger.message}];
            }
            let conversation = Conversations.get(null);
            if (conversation && (!Conversations.hasLive() || trigger.can_trigger_with_open_conversation)) {
              this._sendOneOrMultipleTriggers(conversation, JSON.parse(JSON.stringify(tabTriggers)), trigger, 0);
            }
          }
        }, trigger.time);
        this._scheduled_triggers.push(timeoutId);
      }
    }
  }

  _sendOneOrMultipleTriggers(conversation, messages = null,trigger = null, index = 0) {
    if(messages === null || messages.length === 0) return;

    let triggerMessage = messages.shift().message;
    this.app._triggerInternalEvent('trigger_' + trigger.kind, {
      'time': trigger.time,
      'message': triggerMessage,
      'replace_greetings': trigger.replace_greetings,
      'offline_activated': trigger.offline_activated,
      'random_user': trigger.random_user,
      'embedly_activated': trigger.embedly_activated
    });
    this._message_trigger = triggerMessage
    if (trigger.replace_greetings && conversation.greeting_message && index === 0) {
      conversation.removeMessage(conversation.greeting_message);
    }
    let message         = new Message(MS.bot, triggerMessage);
    message.parser      = Message.PARSER.HTML

    message.trigger_id  = trigger.id;

    if (trigger.random_user) {
      var user = this.app._widget_users[Math.floor(Math.random() * this.app._widget_users.length)]
      message.name = user['name'];
      message.image = user['image'];
    }

    conversation.addMessage(message);

    if (trigger.replace_greetings && index === 0)
      conversation.reorderMessage(message, 0);

    setTimeout( () => {
      this._sendOneOrMultipleTriggers(conversation, messages, trigger, index + 1);
    }, 2000)
  }

  async sendTriggerTooltip(trigger) {
    await Dom.get('tooltip').buildIfNeeded();

    this.app._triggerInternalEvent('trigger_' + trigger.kind, {
      'name': trigger.name,
      'time': trigger.time,
      'message': trigger.message,
      'side': trigger.side,
      'element_id': trigger.element_id,
      'offline_activated': trigger.offline_activated,
      'embedly_activated': trigger.embedly_activated
    });

    var element = Dom.findById('parent', trigger.element_id.replace(/^#/, ''));

    if(element) {
      var element_rect  = element.getBoundingClientRect()

      var element_top     = element_rect.top + Dom.parent.scrollY
      var element_left    = element_rect.left + Dom.parent.scrollX

      var element_right   = element_left + element_rect.width
      var element_bottom  = element_top + element_rect.height

      Dom.removeClass('tooltip', '#slaask-tooltip-' + trigger.side + '-arrow-inner', 'slaask-hidden');

      Dom.findById('tooltip', 'slaask-tooltip-title').innerHTML   = this.app._askTechParser.Emoji.emojify(this.app._askTechParser.parseMessageVariables(trigger.name));
      Dom.findById('tooltip', 'slaask-tooltip-content').innerHTML = trigger.message

      Dom.get('tooltip').fakeSize("current", 0);
      Dom.removeClass('tooltip', 'slaask-hidden');

      let tooltip = Dom.get('tooltip').container;

      this._setTimeout(() => {
        Dom.get('tooltip').realSize();
        switch (trigger.side) {
          case 'top':
            tooltip.style['top']  = (element_top - Math.round(parseFloat(((tooltip.offsetHeight))))) + 'px';
            tooltip.style['left'] = element_left + (element_rect.width / 2) - (tooltip.offsetWidth / 2) + 'px';
            break;

          case 'bottom':
            tooltip.style['top']  = element_bottom + 'px';
            tooltip.style['left'] = element_left + (element_rect.width / 2) - (tooltip.offsetWidth / 2) + 'px';
            break;

          case 'left':
            tooltip.style['top']  = element_top - (tooltip.offsetHeight / 2) + (element_rect.height / 2) + 'px'
            tooltip.style['left'] = element_left - (tooltip.offsetWidth) - 15 + 'px'
            break;

          case 'right':
            tooltip.style['top']  = element_top - (tooltip.offsetHeight / 2) + (element_rect.height / 2) + 'px'
            tooltip.style['left'] = element_right + 15 + 'px'
            break;
        }
      }, 30);


      var elementsCheck = [];
      var fixed         = false

      elementsCheck.push(element)

      while(element.parentNode) {
        elementsCheck.unshift(element.parentNode)
        element = element.parentNode;
      }

      for (var i = elementsCheck.length - 1; i >= 0; i--) {
        if (typeof elementsCheck[i].style != 'undefined') {
          if (Dom.parent.getComputedStyle(elementsCheck[i]).getPropertyValue('position') == 'fixed') {
            tooltip.style['position'] = 'fixed'
          }
        }
      }

      this.triggerDisplayed(trigger)

      Dom.findById('tooltip', 'slaask-tooltip-header-cross').addEventListener("click", (event) => {
        event.preventDefault();
        Dom.addClass('tooltip', 'slaask-hidden');
      });
    }
  }

  async sendTriggerAlert(trigger, html_safe) {
    await Promise.all([
      Dom.get('alert').buildIfNeeded(),
      Dom.get('alert-overlay').buildIfNeeded()
    ]);

    if (trigger.kind == 'alert') {
      this.app._triggerInternalEvent('trigger_' + trigger.kind, {
        'name': trigger.name,
        'time': trigger.time,
        'message': trigger.message,
        'cta_text': trigger.cta_text,
        'cta_action': trigger.cta_action,
        'black': trigger.blank,
        'cancel_text': trigger.cancel_text,
        'offline_activated': trigger.offline_activated,
        'embedly_activated': trigger.embedly_activated
      });
    } else {
      this.app._triggerInternalEvent('trigger_' + trigger.kind, {
        'name': trigger.name,
        'time': trigger.time,
        'message': trigger.message,
        'cta_text': trigger.cta_text,
        'cta_action': trigger.cta_action,
        'black': trigger.blank,
        'cancel_text': trigger.cancel_text,
        'input_placeholder': trigger.input_placeholder,
        'offline_activated': trigger.offline_activated,
        'embedly_activated': trigger.embedly_activated
      });
    }

    if (trigger.kind == 'alert_email' && this.app._user_infos && this.app._user_infos['more'] && this.app._user_infos['more']['email'] != null) {
      return true
    }

    Dom.get('alert').fakeSize("current", this.app.getScreenHeight());

    Dom.addClass('alert', 'slaask-alert-loading');
    Dom.removeClass('alert', 'slaask-hidden');
    Dom.removeClass('alert-overlay', 'slaask-hidden');

    if(trigger.name) {
      Dom.findById('alert', 'slaask-alert-title').innerHTML = this.app._askTechParser.Emoji.emojify(this.app._askTechParser.parseMessageVariables(trigger.name));
    }

    if(trigger.title) {
      Dom.findById('alert', 'slaask-alert-title').innerHTML = this.app._askTechParser.Emoji.emojify(this.app._askTechParser.parseMessageVariables(trigger.title));
    }

    if(html_safe) {
      Dom.addClass('alert', 'slaask-alert-xl');
      Dom.addClass('alert', '#slaask-alert-cta', 'slaask-hidden');
      Dom.findById('alert', 'slaask-alert-content-box').innerHTML = this.app._askTechParser.parseMessageVariables(trigger.message)
    } else {
      if(false) {
      // if(trigger.embedly_activated) {
        Dom.findById('alert', 'slaask-alert-content-box').innerHTML = this.app._askTechParser.parseMessageVariables(trigger.message)
      } else {
        Dom.findById('alert', 'slaask-alert-content-box').innerHTML = this.app._askTechParser.parseMessageVariables(trigger.message)
      }
    }

    if(trigger.cancel_text == null || trigger.cancel_text == '') {
      Dom.addClass('alert', '#slaask-alert-cancel', 'slaask-hidden');
    } else {
      Dom.findById('alert', 'slaask-alert-cancel').innerHTML      = this.app._askTechParser.Emoji.emojify(trigger.cancel_text)
    }


    if(trigger.cta_text == null || trigger.cta_text == '') {
      Dom.addClass('alert', '#slaask-alert-cta-button', 'slaask-hidden');
    } else {
      Dom.findById('alert', 'slaask-alert-cta-button').innerHTML  = this.app._askTechParser.Emoji.emojify(trigger.cta_text);
    }

    if (Dom.findAll('alert', '.youtube-preview-container')[0]) {
      Dom.findAll('alert', '.youtube-preview-container')[0].addEventListener('click', (e) => {
        let element = e.currentTarget
        let videoId = element.querySelectorAll('img')[0].src.split('/vi/')[1].split('/')[0]

        element.innerHTML = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&controls=1&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      })
    }

    if(trigger.kind == 'alert_email') {
      Dom.addClass('alert', 'slaask-alert-email');
      Dom.removeClass('alert', '#slaask-alert-input-box', 'slaask-hidden');
      Dom.findById('alert', 'slaask-alert-input').placeholder = trigger.input_placeholder

      if(trigger.ask_firstname) {
        Dom.removeClass('alert', '#slaask-alert-input-firstname', 'slaask-hidden');
        Dom.removeClass('alert', '#slaask-alert-input-lastname', 'slaask-hidden');

        Dom.findById('alert', 'slaask-alert-input-firstname').placeholder = trigger.firstname_placeholder
        Dom.findById('alert', 'slaask-alert-input-lastname').placeholder  = trigger.lastname_placeholder
      }

      Dom.findById('alert', 'slaask-alert-cta-button').addEventListener("click", (event) => {
        event.preventDefault()

        this.removeAlert()

        let email_value = Dom.findById('alert', 'slaask-alert-input').value

        if(trigger.ask_firstname) {
          let firstname_value = Dom.findById('alert', 'slaask-alert-input-firstname').value
          let lastname_value  = Dom.findById('alert', 'slaask-alert-input-lastname').value

          if((firstname_value && firstname_value != '') || (lastname_value && lastname_value != '')) {
            var infos = {
              'key': this.app._api_key,
              'token': this.app._guest_token,
              'attr': 'name',
              'value': firstname_value + ' ' + lastname_value,
              'email_asked': false,
              'no_message': true,
            }

            Ajax.call('/api/update_visitor_email', infos);
          }
        }

        if(email_value && email_value != '') {
          var infos = {
            'key': this.app._api_key,
            'token': this.app._guest_token,
            'attr': 'email',
            'value': email_value,
            'email_asked': true,
            'no_message': true,
            'trigger_id': trigger.id
          }

          if(!this.app._user_infos) { this.app._user_infos = {} }
          if(!this.app._user_infos['more']) { this.app._user_infos['more'] = {} }

          this.app._user_infos['more']['email'] = email_value

          this.app._triggerInternalEvent('email_captured', {})

          Ajax.call('/api/update_visitor_email', infos);
        }
      });
    } else {
      Dom.findById('alert', 'slaask-alert-cta-button').href= trigger.cta_action;
      Dom.findById('alert', 'slaask-alert-cta-button').addEventListener("click", (event) => {
        Dom.findById('alert', 'slaask-alert-content-box').innerHTML = ''

        Dom.addClass('alert', 'slaask-hidden');
        Dom.addClass('alert-overlay', 'slaask-hidden');

        if (trigger.cta_action != null && trigger.cta_action != '') {
          this.triggerClicked(trigger)
          if (trigger.blank) {
            event.preventDefault()
            let win = window.open(trigger.cta_action, '_blank');
            win.focus();
          }
        }
      });
    }

    this._setTimeout(() => {
      this.replaceAlert()
    }, 100);

    let images = Dom.findAll('alert', 'img')

    for (let i = 0; i < images.length; i++) {
      let image = images[i]
      Utils.addClass(image, 'slaask-image-loading');

      image.onload = () => {
        Utils.removeClass(image, 'slaask-image-loading');
        this.app._triggerInternalEvent('resize')
        // this.replaceAlert()
      }
    }
  }

  async sendTriggerTopbar(trigger) {
    await Dom.get('topbar').buildIfNeeded();

    this.app._triggerInternalEvent('trigger_' + trigger.kind, {
      'time': trigger.time,
      'message': trigger.message,
      'color': trigger.color,
      'cta_text': trigger.cta_text,
      'cta_action': trigger.cta_action,
      'black': trigger.blank,
      'offline_activated': trigger.offline_activated,
      'embedly_activated': trigger.embedly_activated
    });

    if (trigger.cta_text == null || trigger.cta_text == '') {
      Dom.addClass('topbar', '#slaask-topbar-form', 'slaask-hidden');
    } else {
      Dom.removeClass('topbar', 'slaask-topbar-form', 'slaask-hidden');
    }

    Dom.findById('topbar', 'slaask-topbar-button').innerHTML                   = trigger.cta_text;
    if(trigger.inverse_colors) {
      Dom.findById('topbar', 'slaask-topbar').style['background-color']           = this.app._title_color
      Dom.findById('topbar', 'slaask-topbar').style['color']                      = this.app._window_color
      Dom.findAll('topbar', '.slaask-topbar-close-button svg')[0].style['stroke'] = this.app._window_color
      Dom.findById('topbar', 'slaask-topbar-button').style['background-color']    = this.app._window_color
      Dom.findById('topbar', 'slaask-topbar-button').style['color']               = this.app._title_color
    } else {
      Dom.findById('topbar', 'slaask-topbar').style['background-color']           = this.app._window_color
      Dom.findById('topbar', 'slaask-topbar').style['color']                      = this.app._title_color
      Dom.findAll('topbar', '.slaask-topbar-close-button svg')[0].style['stroke'] = this.app._title_color
      Dom.findById('topbar', 'slaask-topbar-button').style['background-color']    = this.app._title_color
      Dom.findById('topbar', 'slaask-topbar-button').style['color']               = this.app._window_color
    }
    Dom.findById('topbar', 'slaask-topbar-text').innerHTML                     = '<p>' + trigger.message + '</p>'

    Dom.findById('topbar', 'slaask-topbar-close-button').addEventListener("click", (event) => {
      event.preventDefault()

      this.removeTopbar()
    });

    Dom.findById('topbar', 'slaask-topbar-button').addEventListener("click", (event) => {
      event.preventDefault()

      this.removeTopbar()

      if (trigger.cta_action != null && trigger.cta_action != '') {
        this.triggerClicked(trigger)

        if (trigger.blank) {
          var win = Dom.parent.open(trigger.cta_action, '_blank');
          win.focus();
        } else {
          Dom.parent.location = trigger.cta_action;
        }
      }
    });

    Dom.get('topbar').fakeSize("current", 0);
    Dom.removeClass('topbar', 'slaask-hidden');

    const setTopbarHeight = () => {
      Dom.get('topbar').realSize();
      this._topbar_height = Dom.get('topbar').element.offsetHeight;
      this.moveForTopbar();
    };

    /**
     * The topbar height is a crucial information for the next steps.
     * The font alters its height, and there is no way to get an event when it
     * is loaded.
     * The loading is usually fast, since the resource has been cached
     * by other Components beforehand.
     */
    if (document.fonts && document.fonts.check) {
      const checks = [0, 100, 500, 1000]
      for (let i = 0; i < checks.length; i++) {
        if (Dom.get('topbar').document.fonts.check('16px Nunito')) {
          setTopbarHeight();
          return;
        }
        await Utils.delay(checks[i])
      }
      Utils.log("Could't find Nunito font");
      setTopbarHeight();
    } else {
      setTimeout(setTopbarHeight, 500)
    }
  }

  sendManyToSlackAlert(message) {
    Dom.get('widget').when('ready').then(() => {
      Dom.removeClass('widget', '#slaask-widget-notify-alert-container', 'slaask-hidden');
      Dom.addClass('widget', '#slaask-widget-views-container', 'slaask-widget-container-with-notify-alert');
      Dom.findById('widget', 'slaask-widget-notify-alert-title-span').innerHTML = Conversations.getMessageContent(message, true);

      Views.getByName('conversation').scrollToBottom();
    });

    Notifier.displayBubble(message);
  }

  stopManyToSlackAlert() {
    Dom.get('widget').when('ready').then(() => {
      Dom.removeClass('widget', '#slaask-widget-views-container', 'slaask-widget-container-with-notify-alert');
      Dom.addClass('widget', '#slaask-widget-notify-alert-container', 'slaask-hidden');
      Dom.findById('widget', 'slaask-widget-notify-alert-title-span').innerHTML = '';
    });
  }

  triggerClicked(trigger) {
    Ajax.call('/api/click_trigger', { key: this.app._api_key, guest_id: this.app._guest_id, trigger_id: trigger.id })
  }

  triggerDisplayed(trigger) {
    Ajax.call('/api/read_trigger', { key: this.app._api_key, guest_id: this.app._guest_id, trigger_id: trigger.id })
  }

  replaceAlert() {
    if (Dom.get('alert').isReady()) {
      Dom.get('alert').realSize();
    }
  }

  removeAlert() {
    if (Dom.get('alert').isReady()) {
        Dom.findById('alert', 'slaask-alert-content-box').innerHTML = ''

        Dom.addClass('alert', 'slaask-hidden');
        Dom.addClass('alert-overlay', 'slaask-hidden');
    }
  }

  removeTopbar() {
    this.undoMoveForTopbar();
    Dom.addClass('topbar', 'slaask-hidden');
  }

  moveForTopbar() {
    if (Dom.get('topbar').isReady()) {
      const htmlTag = Dom.find('parent', 'html');
      Dom.addClass('parent', htmlTag, 'slaask-moved-for-topbar');

      if (this.app._make_room_for_topbar) {
        this._elements_moved_for_topbar = []
        const elements      = Dom.findAll('parent', 'body *');
        const len           = elements.length;
        const topbarHeight  = this._topbar_height;
        const viewportHeigh = window.innerHeight

        for (let i=0; i<len; i++) {
          const computed = Dom.parent.getComputedStyle(elements[i],null);
          if (computed['position'] == 'fixed') {
            if(!/(slaask)|(asktech)/g.test(elements[i].id)) {
              if (computed['top'] && parseFloat(computed['top'].replace('px', '')) < viewportHeigh / 2) {
                this._elements_moved_for_topbar.push(elements[i])
                Dom.addClass('parent', elements[i], 'slaask-moved-for-topbar');
                elements[i].style['top'] = (parseInt(Dom.parent.getComputedStyle(elements[i],null).getPropertyValue('top')) + topbarHeight) + 'px'
              }
            }
          }
        }


        htmlTag.style['position'] = "relative";
        htmlTag.style['top'] = (parseInt(Dom.parent.getComputedStyle(htmlTag,null).getPropertyValue('top')) || 0 + topbarHeight) + 'px';
        htmlTag.style['height'] = "calc(100% - " + topbarHeight + "px)";
      }

      Dom.get('topbar').on('size_changed', (size) => {
        this.app._triggerInternalEvent('topbar_resize', {
          height: parseFloat(size.height.replace('px', ''))
        })
      }).until(this.app, 'topbar_hide')

      this.app._triggerInternalEvent('topbar_show', {
        height: this._topbar_height
      })
    }
  }

  undoMoveForTopbar() {
    if (Dom.get('topbar').isReady()) {
      if (this._topbar_height > 0) {
        let htmlTag      = Dom.find('parent', 'html');

        if (this.app._make_room_for_topbar) {
          let len          = this._elements_moved_for_topbar.length;
          let elems        = this._elements_moved_for_topbar;
          let topbarHeight = this._topbar_height;

          for (var i=0;i<len;i++) {
            if (Dom.parent.getComputedStyle(elems[i],null).getPropertyValue('position') == 'fixed') {
              if(!/(slaask)|(asktech)/g.test(elems[i].id)) {
                Dom.removeClass('parent', elems[i], 'slaask-moved-for-topbar');
                elems[i].style['top'] = (parseInt(Dom.parent.getComputedStyle(elems[i],null).getPropertyValue('top')) - topbarHeight) + 'px'
              }
            }
          }

          htmlTag.style['top'] = (parseInt(Dom.parent.getComputedStyle(htmlTag,null).getPropertyValue('top')) - topbarHeight) + 'px'
          htmlTag.style['height'] = "";
          htmlTag.style['position'] = "";
        }

        this._topbar_height = 0;
        Dom.removeClass('parent', htmlTag, 'slaask-moved-for-topbar');

        this.app._triggerInternalEvent('topbar_hide')
      }
    }
  }

  _isWelcomeBubbleReplaced() {
    return this._greetings_replaced;
  }

  destroy() {
    this.undoMoveForTopbar();
    super.destroy();
  }

});
